import { styled } from "styled-components";
import { SingleStatProps } from "./SingleStat.types";
import { typographyMixin } from "../../typography";

export const StyledSingleStat = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  ${typographyMixin}
`;

export const SingleStatValue = styled.div`
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
`;

export const SingleStatHeader = styled.div`
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
`;

export const StyledStatGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

  > div:not(:first-child) {
    border-left: 2px solid rgba(54, 56, 61, 0.2);
  }
`;
